import Captcha from './Captcha';
import './style/captcha.less';

export default Captcha;
